import { render } from "./PlanArchive.vue?vue&type=template&id=5b362760&scoped=true"
import script from "./PlanArchive.vue?vue&type=script&lang=js"
export * from "./PlanArchive.vue?vue&type=script&lang=js"

import "./PlanArchive.vue?vue&type=style&index=0&id=5b362760&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b362760"]])

export default __exports__